export default __webpack_public_path__ + "static/media/OneDriveLogo.f296278d.png";